import { ButtonIcon } from "@insite/mobius/Button";
import buttonTypes from "@insite/mobius/Button/buttonTypes";
import { resolveColor } from "@insite/mobius/utilities";
import get from "@insite/mobius/utilities/get";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import { ButtonProps } from "@starter/MobiusOverrides/Button/Props";
import { css } from "styled-components";

type ButtonTypesProps<T extends (...args: any) => any> = Parameters<T>[0] & Pick<ButtonProps, "hoverTextColor">;

const baseButtonTypes = { ...buttonTypes };

Object.assign(buttonTypes, {
    solid: (props: ButtonTypesProps<typeof buttonTypes.solid>) => {
        const contrastColor = getContrastColor(props._color, props.theme);
        const hoverTextColor = resolveColor(props.hoverTextColor, props.theme);
        const disabledColor = get(props.theme, "colors.button.disabled.main") || resolveColor("common.disabled", props.theme); // Store Custom Code
        const disabledContrast = get(props.theme, "colors.button.disabled.contrast") || resolveColor("common.background", props.theme); // Store Custom Code

        return css`
            ${baseButtonTypes.solid(props)}

            ${ButtonIcon} {
                color: ${contrastColor};
            }

            &:not(:disabled):hover {
                color: ${hoverTextColor};

                ${ButtonIcon} {
                    color: ${hoverTextColor};
                }
            }

            /* Store Custom Code - Start */
            &:disabled {
                background: ${disabledColor};
                border-color: ${disabledColor};
                color: ${disabledContrast};
            }
            /* Store Custom Code - End */
        `;
    },
    outline: (props: ButtonTypesProps<typeof buttonTypes.outline>) => {
        const contrastColor = getContrastColor(props._color, props.theme);
        const hoverTextColor = resolveColor(props.hoverTextColor, props.theme);
        const disabledColor = get(props.theme, "colors.button.disabled.main") || resolveColor("common.disabled", props.theme); // Store Custom Code

        return css`
            ${baseButtonTypes.outline(props)}

            ${ButtonIcon} {
                color: ${contrastColor};
            }

            &:not(:disabled):hover {
                color: ${hoverTextColor};

                ${ButtonIcon} {
                    color: ${hoverTextColor};
                }
            }

            /* Store Custom Code - Start */
            &:disabled {
                border-color: ${disabledColor};
                color: ${disabledColor};
            }
            /* Store Custom Code - End */
        `;
    },
});
